import React from "react";
import { RouterProvider, createBrowserRouter } from "react-router-dom";
import { Navigate, RouteObject } from "react-router";
import GlobalEntitiesList from "./components/global-entities/GlobalEntities";
import EntityDashboard from "./components/global-entities/entity-dashboard/EntityDashboard";
import Entities from "./Pages/Entities";
import EntityOnboard from "./Pages/EntityOnboard";
import GeneralInformation from "./components/entities/general-information/GeneralInformation";
import Addresses from "./components/entities/address/Addresses";
import Settings from "./Pages/Settings";
import MyProfile from "./components/settings/my-profile/MyProfile";
import Users from "./components/settings/users/Users";
import Personnel from "./components/entities/key-personnel/Personnel";
import ShareHolders from "./components/share-holders/ShareHolders";
import UserAccess from "./Pages/UserAccess/index";
import UserInfo from "./Pages/UserAccess/components/UserInfo";
import EntityAccess from "./Pages/UserAccess/components/EntityAccess";
import Directors from "./components/directors-form/Directors";
import DirectorDetails from "./components/directors-form/director-details/DirectorDetails";
import AddDirectors from "./components/directors-form/AddDirectors";
import UpdateDirectors from "./components/directors-form/UpdateDirectors";
import EditShareHolders from "./components/share-holders/EditShareHolders";
import LSPOnboarding from "./Pages/Lsp/onboarding";
import LSPListing from "./Pages/Lsp/listing";
import Lsps from "./Pages/Lsp/updating";
import LspGenInfo from "./Pages/Lsp/updating/components/LspGenInfo";
import LspTradingAddress from "./Pages/Lsp/updating/components/LspTradingAddress";
import TradingAddressq from "./Pages/Lsp/onboarding/components/TradingAddress";
import LspPortfolio from "./Pages/Lsp/updating/components/LspPortfolio";
import Forbidden from "./Pages/Forbidden";
import Gated from "./components/gated/Gated";
import LSPDashboard from "./Pages/Lsp/dashboard";
import EntityCalendar from "./Pages/EntityCalendar";
import Milestones from "./Pages/Process/components/tabs/milestones/Milestones";

import ProcessLayoutWrapper from "./Pages/Process/components/ProcessLayoutWrapper";
import InternalConversations from "./Pages/Process/components/tabs/internal-conversations/InternalConversations";
import PublicConversations from "./Pages/Process/components/tabs/public-conversations/PublicConversations";
import ProcessAttachments from "./Pages/Process/components/tabs/attachments/ProcessAttachments";

import ServiceFileDocuments from "./Pages/EntityFileDocuments/components/ServiceFileDocuments";
import FileDocumentsLayout from "./Pages/EntityFileDocuments/index";
import EntityFileDocuments from "./Pages/EntityFileDocuments/components/EntityFileDocuments";
import ProcessFileDocuments from "./Pages/EntityFileDocuments/components/ProcessFileDocuments";
import TypeFileDocument from "./Pages/EntityFileDocuments/components/TypeFileDocument";
import FeatureFlagged from "./components/feature-flagged/FeatureFlagged";
import { FEATURE_FLAGS } from "./config/ff";
import Requests from "./Pages/Requests";
import RequestLayoutWrapper from "./Pages/Requests/dashboard/RequestLayoutWrapper";
import RequestConversation from "./Pages/Requests/dashboard/RequestConversation";
import RequestAttachments from "./Pages/Requests/dashboard/RequestAttachments";
import { REQUEST_TYPES } from "./Pages/Requests/useRequest";
import OfficersAttornyRegistry from "./Pages/Officers/OfficersAttornyRegistry";
import AddOfficers from "./components/officers-form/AddOfficers";
import EntityPlus from "./components/entities/entity-plus/EntityPlus";
import OfficerDetails from "./components/officers-form/officer-details/OfficerDetails";
import OfficerPersonalInfo from "./components/officers-form/officer-details/OfficerPersonalInfo";
import OfficerAttacments from "./components/officers-form/officer-details/OfficerAttacments";
import AddShareholder from "./components/share-holders/AddShareholder";
import Callback from "./Pages/Callback";
// import DeeplinkTest from "./Pages/DeeplinkTest";
import ShareHolderDetail from "./components/share-holders/ShareHolderDetail";
import CoreEntityAttachments from "./components/entities/attachments/CoreEntityAttachments";
import ShareHolderPersonalInfo from "./components/share-holders/ShareHolderPersonalInfo";
import ShareholderProfileAddress from "./components/share-holders/shareholder-details/ShareholderProfileAddress";
import ShareholderRegistry from "./components/share-holders/shareholder-details/ShareholderRegistry";
import ShareholderProfileAttachments from "./components/share-holders/shareholder-details/ShareholderProfileAttachments";
import ActiveServices from "./components/entities/active-services/ActiveServices";
import EntitySettings from "./components/entities/entity-settings/EntitySettings";
import MyDashboard from "./Pages/MyDashboard/MyDashboard";
import MyCalendar from "./Pages/MyCalendar";
import RequestTypeFileDocuments from "./Pages/EntityFileDocuments/components/RequestTypeFileDocuments";
import RequestFileDocuments from "./Pages/EntityFileDocuments/components/RequestFileDocuments";
import EmployeeOnboarding from "./Pages/EmployeeRegistry/components/EmployeeOnboarding";
import Employee from "./Pages/EmployeeRegistry";
import LandingPage from "./Pages/LandingPage";
import EditEmployee from "./Pages/EmployeeRegistry/components/EditEmployee";
import EditPersonalInformation from "./Pages/EmployeeRegistry/components/PersonalInformation/EditPersonalInformation";
import EditLocationAddress from "./Pages/EmployeeRegistry/components/LocationAddress/EditLocationAddress";
import EditEmploymentInformationForm from "./Pages/EmployeeRegistry/components/EmploymentInformation/EditEmploymentInformationForm";
import EditBankInfo from "./Pages/EmployeeRegistry/components/BankInformation/EditBankInfo";
import EmployeeAttachments from "./Pages/EmployeeRegistry/components/Attachments/index";
import PayslipFileDocuments from "./Pages/EntityFileDocuments/components/PayslipFileDocuments";

const routes: RouteObject[] = [
  {
    path: "/callback",
    element: <Callback />,
  },
  {
    path: "/",
    element: <LandingPage />,
  },
  {
    path: "/entities",
    element: <GlobalEntitiesList />,
  },
  {
    path: "/login",
    element: <Navigate to="/" />,
  },
  {
    path: "/entity/:id/directors",
    element: (
      <Gated checkEntity checkLsp={false} checkProcess={false}>
        <Directors />
      </Gated>
    ),
  },
  {
    path: "/directors/:id",
    element: <DirectorDetails />,
  },
  {
    path: "/entity/:entityid/directors/add",
    element: (
      <Gated checkEntity={false} checkLsp={false} checkProcess={false}>
        <AddDirectors />
      </Gated>
    ),
  },
  {
    path: ":entityid/directors/:id/edit",
    element: (
      <Gated checkEntity={false} checkLsp={false} checkProcess={false}>
        <UpdateDirectors />
      </Gated>
    ),
  },
  {
    path: "/entity/:id/share-holders",
    element: (
      <Gated checkEntity checkLsp={false} checkProcess={false}>
        <ShareHolders />
      </Gated>
    ),
  },
  // {
  //   path: "/entity/:id/share-holders/add",
  //   element: (
  //     <Gated checkEntity={false} checkLsp={false} checkProcess={false}>
  //       <AddShareholder />
  //     </Gated>
  //   ),
  // },
  {
    path: "/entity/:id/share-holders/add",
    element: (
      <Gated checkEntity={false} checkLsp={false} checkProcess={false}>
        <AddShareholder />
      </Gated>
    ),
  },
  {
    path: "/share-holders/:id/edit",
    element: (
      <Gated checkEntity={false} checkLsp={false} checkProcess={false}>
        <EditShareHolders />
      </Gated>
    ),
  },
  {
    path: "/share-holders/:id",
    element: <ShareHolderDetail />,
    children: [
      {
        path: "info",
        element: <ShareHolderPersonalInfo />,
      },
      {
        path: "address",
        element: <ShareholderProfileAddress />,
      },
      {
        path: "registry",
        element: <ShareholderRegistry />,
      },
      {
        path: "attachments",
        element: <ShareholderProfileAttachments />,
      },
    ],
  },
  {
    path: "/lsp/onboard",
    element: (
      <FeatureFlagged flag={FEATURE_FLAGS.LSP}>
        <Gated checkEntity={false} checkLsp={false} checkProcess={false}>
          <LSPOnboarding />
        </Gated>
      </FeatureFlagged>
    ),
  },
  {
    path: "/lsp",
    element: (
      <FeatureFlagged flag={FEATURE_FLAGS.LSP}>
        <LSPListing />
      </FeatureFlagged>
    ),
  },
  {
    path: "/entity/:id/dashboard",
    element: (
      <Gated checkEntity checkLsp={false} checkProcess={false}>
        <EntityDashboard />
      </Gated>
    ),
  },
  {
    path: "/entity/:id/calendar",
    element: (
      <FeatureFlagged flag={FEATURE_FLAGS.ENTITY_CALENDAR}>
        <EntityCalendar />
      </FeatureFlagged>
    ),
  },
  {
    path: "/entity/onboard",
    element: (
      <Gated checkEntity={false} checkLsp={false} checkProcess={false}>
        <EntityOnboard />
      </Gated>
    ),
  },
  {
    path: "files/entity/:id",
    element: (
      <FeatureFlagged flag={FEATURE_FLAGS.DOCUMENT_STORAGE}>
        <FileDocumentsLayout />
      </FeatureFlagged>
    ),
    children: [
      {
        index: true,
        element: <EntityFileDocuments />,
      },
      {
        path: "services/:service_id",
        element: <ServiceFileDocuments />,
      },
      {
        path: "services/:service_id/:type",
        element: <TypeFileDocument />,
      },
      {
        path: "services/:service_id/:type/process/:process_id",
        element: <ProcessFileDocuments />,
      },
      {
        path: "services/:service_id/:type/:process_id",
        element: <ProcessFileDocuments />,
      },
      {
        path: "services/:service_id/:type/process/:process_id/payslips",
        element: <PayslipFileDocuments />,
      },
      {
        path: "requests/:service_id",
        element: <ServiceFileDocuments />,
      },
      {
        path: "requests/:service_id/:type",
        element: <TypeFileDocument />,
      },
      {
        path: "requests/:service_id/:type/request-type/:request_type",
        element: <RequestTypeFileDocuments />,
      },
      {
        path: "requests/:service_id/:type/request-type/:request_type/:request_id",
        element: <RequestFileDocuments />,
      },
    ],
  },
  {
    path: "/entity/:id/entity-settings",
    element: (
      <FeatureFlagged flag={FEATURE_FLAGS.UPDATE_ACTIVE_SERVICES}>
        <Gated checkEntity checkLsp={false} checkProcess={false}>
          <EntitySettings />
        </Gated>
      </FeatureFlagged>
    ),
    children: [
      {
        path: "active-services",
        element: <ActiveServices />,
      },
    ],
  },

  {
    path: "/entity/:id",
    element: (
      <Gated checkEntity checkLsp={false} checkProcess={false}>
        <Entities />
      </Gated>
    ),
    children: [
      {
        path: "info",
        element: <GeneralInformation />,
      },
      {
        path: "entity-plus",
        element: <EntityPlus />,
      },
      {
        path: "addresses",
        element: <Addresses />,
      },
      {
        path: "key-personnel",
        element: <Personnel />,
      },
      {
        path: "attachments",
        element: <CoreEntityAttachments />,
      },
    ],
  },
  {
    path: "/entity/:id/officers",
    element: <OfficersAttornyRegistry type={"officer"} />,
  },
  {
    path: "/entity/:id/powers-of-attorney",
    element: <OfficersAttornyRegistry type={"power-of-attorney"} />,
  },
  {
    path: "/entity/:id/employee",
    element: (
      <FeatureFlagged flag={FEATURE_FLAGS.EMPLOYEE_REGISTRY}>
        <Employee />
      </FeatureFlagged>
    ),
  },
  {
    path: "/entity/:id/employee-registry",
    element: (
      <FeatureFlagged flag={FEATURE_FLAGS.EMPLOYEE_REGISTRY}>
        <EmployeeOnboarding />
      </FeatureFlagged>
    ),
  },
  {
    path: "/employee/:id",
    element: (
      <FeatureFlagged flag={FEATURE_FLAGS.EMPLOYEE_REGISTRY}>
        <EditEmployee />
      </FeatureFlagged>
    ),
    children: [
      {
        path: "info",
        element: <EditPersonalInformation />,
      },
      {
        path: "address",
        element: <EditLocationAddress />,
      },
      {
        path: "employment-information",
        element: <EditEmploymentInformationForm />,
      },
      {
        path: "bank-information",
        element: <EditBankInfo />,
      },
      {
        path: "attachments",
        element: <EmployeeAttachments />,
      },
    ],
  },
  {
    path: "/lsp/:id/dashboard",
    element: (
      <FeatureFlagged flag={FEATURE_FLAGS.LSP}>
        <Gated checkEntity={false} checkLsp checkProcess={false}>
          <LSPDashboard />
        </Gated>
      </FeatureFlagged>
    ),
  },
  {
    path: "/lsp/:id",
    element: (
      <FeatureFlagged flag={FEATURE_FLAGS.LSP}>
        <Gated checkEntity={false} checkLsp={false} checkProcess={false}>
          <Lsps />
        </Gated>
      </FeatureFlagged>
    ),
    children: [
      {
        path: "info",
        element: <LspGenInfo />,
      },
      {
        path: "addresses",
        element: <LspTradingAddress />,
      },
      {
        path: "customer-portfolio",
        element: <LspPortfolio />,
      },
      {
        path: "key-personnel",
        element: <Personnel />,
      },
    ],
  },
  {
    path: "/settings",
    element: <Settings />,
    children: [
      {
        path: "my-profile",
        element: <MyProfile />,
      },
      {
        path: "users",
        element: (
          <Gated checkEntity={false} checkLsp={false} checkProcess={false}>
            <Users />
          </Gated>
        ),
      },
    ],
  },
  {
    path: "/settings/users/:id",
    element: (
      <Gated checkEntity={false} checkLsp={false} checkProcess={false}>
        <UserAccess />
      </Gated>
    ),
    children: [
      {
        path: "user-service-access",
        element: <EntityAccess />,
      },
      {
        path: "user-info",
        element: <UserInfo />,
      },
    ],
  },
  {
    path: "/forbidden",
    element: <Forbidden />,
  },
  {
    path: "/process/:id/",
    element: (
      <Gated checkEntity={false} checkLsp={false} checkProcess>
        <ProcessLayoutWrapper />
      </Gated>
    ),
    children: [
      {
        path: "milestones",
        element: <Milestones />,
      },
      {
        path: "conversations/internal",
        element: (
          <FeatureFlagged flag={FEATURE_FLAGS.MESSAGING}>
            <InternalConversations />
          </FeatureFlagged>
        ),
      },
      {
        path: "conversations/public",
        element: (
          <FeatureFlagged flag={FEATURE_FLAGS.MESSAGING}>
            <PublicConversations />
          </FeatureFlagged>
        ),
      },
      {
        path: "attachments",
        element: (
          <FeatureFlagged flag={FEATURE_FLAGS.DOCUMENT_STORAGE}>
            <ProcessAttachments />
          </FeatureFlagged>
        ),
      },
    ],
  },
  {
    path: "/requests",
    element: (
      <FeatureFlagged flag={FEATURE_FLAGS.REQUESTS}>
        <Requests
          requestType={REQUEST_TYPES.AD_HOC}
          key={REQUEST_TYPES.AD_HOC}
        />
      </FeatureFlagged>
    ),
  },
  {
    path: "/requests/:id/",
    element: (
      <FeatureFlagged flag={FEATURE_FLAGS.REQUESTS}>
        <Gated checkEntity={false} checkLsp={false} checkProcess>
          <RequestLayoutWrapper requestType={REQUEST_TYPES.AD_HOC} />
        </Gated>
      </FeatureFlagged>
    ),
    children: [
      {
        path: "conversation",
        element: <RequestConversation requestType={REQUEST_TYPES.AD_HOC} />,
      },
      {
        path: "attachments",
        element: (
          <FeatureFlagged flag={FEATURE_FLAGS.DOCUMENT_STORAGE}>
            <RequestAttachments />
          </FeatureFlagged>
        ),
      },
    ],
  },
  {
    path: "/escalations",
    element: (
      <FeatureFlagged flag={FEATURE_FLAGS.ESCALATIONS}>
        <Requests
          requestType={REQUEST_TYPES.ESCALATION}
          key={REQUEST_TYPES.ESCALATION}
        />
      </FeatureFlagged>
    ),
  },
  {
    path: "/escalations/:id/",
    element: (
      <FeatureFlagged flag={FEATURE_FLAGS.ESCALATIONS}>
        <Gated checkEntity={false} checkLsp={false} checkProcess>
          <RequestLayoutWrapper requestType={REQUEST_TYPES.ESCALATION} />
        </Gated>
      </FeatureFlagged>
    ),
    children: [
      {
        path: "conversation",
        element: <RequestConversation requestType={REQUEST_TYPES.ESCALATION} />,
      },
    ],
  },
  {
    path: "/entity/:id/officers/add",
    element: (
      <Gated checkEntity={false} checkLsp={false} checkProcess={false}>
        <AddOfficers type="officer" />
      </Gated>
    ),
  },
  {
    path: "/entity/:id/powers-of-attorney/add",
    element: (
      <Gated checkEntity={false} checkLsp={false} checkProcess={false}>
        <AddOfficers type="power-of-attorney" />
      </Gated>
    ),
  },
  {
    path: "/officers/:id",
    element: <OfficerDetails type="officer" />,
    children: [
      {
        path: "info",
        element: <OfficerPersonalInfo />,
      },
      {
        path: "attachments",
        element: <OfficerAttacments type="officer" />,
      },
    ],
  },
  {
    path: "/powers-of-attorney/:id",
    element: <OfficerDetails type="power-of-attorney" />,
    children: [
      {
        path: "info",
        element: <OfficerPersonalInfo />,
      },
      {
        path: "attachments",
        element: <OfficerAttacments type="power-of-attorney" />,
      },
    ],
  },
  {
    path: "/my-dashboard",
    element: (
      <FeatureFlagged flag={FEATURE_FLAGS.MY_DASHBOARD}>
        <MyDashboard />
      </FeatureFlagged>
    ),
  },
  {
    path: "/calendar",
    element: (
      <FeatureFlagged flag={FEATURE_FLAGS.MY_CALENDAR}>
        <MyCalendar />
      </FeatureFlagged>
    ),
  },
];

const router = createBrowserRouter(routes);

const Router = () => {
  return <RouterProvider router={router} />;
};

export default Router;
